module.exports = __webpack_public_path__ + "img/383.e6632f82.png";